import React, { useState, useEffect } from "react";
import CarImg from "../../assets/carinspection.png";
import CarImgA from "../../assets/carinspection_A.png";
import FinalImg from "../../assets/finalcheck.png";
import FinalImgA from "../../assets/finalcheck_A.png";
import GeneralImg from "../../assets/generalInfo.png";
import GeneralImgA from "../../assets/generalInfo_A.png";
import Header from "../Header";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTabIndex } from "../actions";
import {
  APL_LINK,
  server_post_data,
  get_needed_oilcheck_data,
} from "../../ServiceConnection/serviceconnection";
import {
  handleError,
  mondayDayYearFormat,
} from "../../CommonJquery/CommonJquery";
import GeneralInfoOilCheck from "./GeneralInfoOilCheck";
import PreviewOilCheckForm from "./PreviewOilCheckForm";
import OilCheckOnly from "./OilCheckOnly";

function OilCheckForm({ id, id2, FromCome }) {
  const [count, setCount] = useState(0);
  const dispatch = useDispatch();
  const activeTabIndex = useSelector((state) => state.activeTabIndex);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [staffData, setStaffData] = useState([]);
  const [cardata, setCarData] = useState([]);
  const [MaintainanceData, setMaintainanceData] = useState([]);
  const [MaintainanceData_prev, setMaintainanceData_prev] = useState([]);
  const [BookingData, setBookingData] = useState([]);
  const [ImageLink, setImageLink] = useState("");
  const [ImageLinkIpass, setImageLinkIpass] = useState("");
  const [selectedReason, setSelectedReason] = useState("");

  useEffect(() => {
    master_data_get();
  }, []);

  useEffect(() => {
    master_data_get();
  }, [count]);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", id);
    fd.append("maintainance_id", id2);
    fd.append("previous_data", 0);

    await server_post_data(get_needed_oilcheck_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setMaintainanceData(Response.data.message.maintenance_data);
          setMaintainanceData_prev(Response.data.message.last_maintenance_data);
          setStaffData(Response.data.message.staff_data);
          setCarData(Response.data.message.car_data);
          setBookingData(Response.data.message.booking_data);
          setImageLink(APL_LINK + Response.data.message.image_link);
          setImageLinkIpass(APL_LINK + Response.data.message.ipass_link);
          console.log(Response.data.message);
          console.log(count);
          // Set the reason from existing data
          if (Response.data.message.maintenance_data?.maintenance_reasion) {
            setSelectedReason(
              Response.data.message.maintenance_data.maintenance_reasion
            );
          }
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const tabs = [
    // { label: "Preview Notes", img: GeneralImg, activeImg: GeneralImgA },
    { label: "General Info", img: GeneralImg, activeImg: GeneralImgA },
    { label: "Oil Check", img: CarImg, activeImg: CarImgA },
    {
      label: "Preview Form",
      img: FinalImg,
      activeImg: FinalImgA,
      hidden: true,
    },
  ];

  const renderContent = () => {
    const activeTab = tabs[activeTabIndex];

    switch (activeTabIndex) {
      case 0:
        return (
          <GeneralInfoOilCheck
            MaintainanceData={MaintainanceData}
            ImageLink={ImageLink}
            staffData={staffData}
            setCount={setCount}
            BookingData={BookingData}
            cardata={cardata}
            FromComeData={FromCome}
            onNext={handleNext}
            onBack={handleBack}
          />
        );
      case 1:
        return (
          <OilCheckOnly
            MaintainanceData={MaintainanceData}
            ImageLink={ImageLink}
            staffData={staffData}
            setCount={setCount}
            BookingData={BookingData}
            cardata={cardata}
            FromComeData={FromCome}
            onNext={handleNext}
            onBack={handleBack}
          />
        );
      case 2:
        return (
          <PreviewOilCheckForm
            MaintainanceData={MaintainanceData}
            ImageLink={ImageLink}
            ImageLinkIpass={ImageLinkIpass}
            onNext={handleNext}
            onBack={handleBack}
            FromComeData={FromCome}
            setCount={setCount}
            cardata={cardata}
          />
        );

      default:
        return (
          <GeneralInfoOilCheck
            MaintainanceData={MaintainanceData}
            ImageLink={ImageLink}
            staffData={staffData}
            setCount={setCount}
            BookingData={BookingData}
            cardata={cardata}
            FromComeData={FromCome}
            onNext={handleNext}
            onBack={handleBack}
          />
        );
    }
  };

  const handleTabClick = (index) => {
    dispatch(setActiveTabIndex(index));
  };

  const handleNext = () => {
    const nextIndex = activeTabIndex + 1;
    if (nextIndex < tabs.length) {
      dispatch(setActiveTabIndex(nextIndex));
    }
    window.scrollTo(0, 0);
  };

  const handleBack = () => {
    const prevIndex = activeTabIndex - 1;
    if (prevIndex >= 0) {
      dispatch(setActiveTabIndex(prevIndex));
    }
    window.scrollTo(0, 0);
  };

  return (
    <div className="dashboard">
      <Header />
      <div className="container-lg"></div>
      <div
        className="dashboard_container"
        style={{ backgroundColor: "#ECECEC" }}
      >
        <div className="page_content">
          <div className="page_content_container">
            <div className="page_body">
              <div className="app-container">
                <div className="aminStickyFormHead">
                  <div className="navigation-barMain justify-content-start">
                    {tabs
                      .filter((tab) => !tab.hidden)
                      .map((tab, index) => (
                        <div key={index} className="main_tab_box mb-2">
                          <div
                            className={`nav-itemMain ${
                              activeTabIndex === index ? "active" : ""
                            } ${index <= count ? "" : "eventNone"}`}
                            onClick={() => handleTabClick(index)}
                          >
                            {activeTabIndex === index ? (
                              <img src={tab.activeImg} />
                            ) : (
                              <img src={tab.img} />
                            )}
                            <div className="nav-labelMain">{tab.label}</div>
                          </div>
                        </div>
                      ))}
                  </div>
                  <hr className="hrmaniForm" />
                  <div className="header-info">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex flex-wrap">
                        <span>Date: {mondayDayYearFormat(new Date())}</span>
                        <span className="mx-2" style={{ color: "#000000" }}>
                          |
                        </span>
                        <span>License No.: {cardata?.car_no}</span>
                        <span className="mx-2" style={{ color: "#000000" }}>
                          |
                        </span>
                        <span>Vehicle No.: {cardata?.car_tagline}</span>
                      </div>
                      {activeTabIndex === 0 && (
                        <div className="vehilce_previe_suummry">
                          <span>Vehicle Inspection Summary</span>
                        </div>
                      )}
                      <div>
                        <span>Driver Name: {BookingData?.name}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="content-container">{renderContent()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OilCheckForm;
